import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ClientesList from "../../../components/ClientesList";
import ClienteDetails from "../../../components/ClienteDetails";

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: "100vh"
  },
  paper: {
    minHeight: "100vh",
    backgroundColor: "#fafafa"
  }
}));

const Clientes = ({ tipo }) => {
  const classes = useStyles();
  const [cliente, setCliente] = useState(null);

  return (
    <Grid container className={classes.container}>
      <Grid item md={5}>
        <Paper className={classes.paper} square>
          <ClientesList tipo={tipo} onSelect={setCliente} />
        </Paper>
      </Grid>

      {cliente && (
        <Grid item md={7}>
          <Paper className={classes.paper} square>
            <ClienteDetails cliente={cliente} />
          </Paper>
        </Grid>
      )}
    </Grid>
  );
};

export default Clientes;
